import { Skeleton, SkeletonEventPill } from '../UI/Skeleton';

/**
 * CalendarSkeleton - Loading skeleton for the calendar view
 */
export default function CalendarSkeleton() {
  // Generate 5 weeks of days (35 cells for month grid)
  const days = Array.from({ length: 35 });
  
  // Randomly determine which days have "events" for visual variety
  const daysWithEvents = [3, 5, 8, 12, 15, 18, 22, 25, 28];
  
  return (
    <div className="space-y-4">
      {/* Header skeleton */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Skeleton width="2.5rem" height="2.5rem" rounded="md" />
          <Skeleton width="180px" height="1.75rem" />
          <Skeleton width="2.5rem" height="2.5rem" rounded="md" />
        </div>
        <Skeleton width="100px" height="2.5rem" rounded="md" />
      </div>

      {/* Timezone selector skeleton */}
      <div className="flex justify-end">
        <Skeleton width="200px" height="2rem" rounded="md" />
      </div>

      {/* Calendar grid skeleton */}
      <div 
        className="rounded-lg overflow-hidden"
        style={{ 
          backgroundColor: 'var(--color-bg-canvas)',
          border: '1px solid var(--color-border-subtle)',
        }}
      >
        {/* Day headers */}
        <div className="grid grid-cols-7 border-b" style={{ borderColor: 'var(--color-border-subtle)' }}>
          {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day) => (
            <div 
              key={day}
              className="p-2 text-center"
              style={{ backgroundColor: 'var(--color-bg-surface)' }}
            >
              <Skeleton width="2rem" height="0.875rem" className="mx-auto" />
            </div>
          ))}
        </div>

        {/* Calendar days grid */}
        <div className="grid grid-cols-7">
          {days.map((_, i) => {
            const hasEvents = daysWithEvents.includes(i);
            return (
              <div 
                key={i}
                className="p-2 min-h-[80px] md:min-h-[100px]"
                style={{ 
                  borderRight: (i + 1) % 7 !== 0 ? '1px solid var(--color-border-subtle)' : 'none',
                  borderBottom: i < 28 ? '1px solid var(--color-border-subtle)' : 'none',
                }}
              >
                <Skeleton width="1.5rem" height="1.5rem" className="mb-2" />
                {hasEvents && (
                  <div className="space-y-1 hidden md:block">
                    <SkeletonEventPill />
                    {i % 3 === 0 && <SkeletonEventPill />}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Legend skeleton */}
      <div className="flex justify-center gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="flex items-center gap-2">
            <Skeleton width="0.75rem" height="0.75rem" rounded="full" />
            <Skeleton width="60px" height="0.75rem" />
          </div>
        ))}
      </div>
    </div>
  );
}
